export default __webpack_public_path__ + "static/media/chaletGrandePattern.b8c787de.png";